import { api } from '../lib/api'

export type SecurityOverview = {
  email: string
  email_masked: string
  email_verified: boolean
  phone: string
  phone_masked: string
  phone_verified: boolean
  has_password: boolean
  mfa_enabled: boolean
  last_login?: string
  joined_at?: string
  devices_registered?: number
}

export async function getSecurityOverview() {
  const { data } = await api.get<SecurityOverview>('/api/me/security/')
  return data
}

export async function changePassword(payload: { old_password?: string; new_password: string }) {
  const { data } = await api.post<{ ok: boolean }>('/api/me/security/password/', payload)
  return data
}

export async function requestPhoneOtp(payload: { phone?: string }) {
  const { data } = await api.post<{ ok: boolean }>('/api/users/phone/otp/request/', payload)
  return data
}

export async function verifyPhoneOtp(payload: { code: string }) {
  const { data } = await api.post<{ ok: boolean; phone_verified?: boolean }>('/api/users/phone/otp/verify/', payload)
  return data
}

export type EmailChangeStartResponse = {
  ok: boolean
  pending_email: string
  verification_id: string
  expires_at: string
  email_verified: boolean
}

export async function requestEmailChange(payload: { email: string }) {
  const { data } = await api.post<EmailChangeStartResponse>('/api/me/contact/email/change/', payload)
  return data
}

export async function resendEmailChangeVerification() {
  const { data } = await api.post<{ ok: boolean; pending_email: string; verification_id: string; expires_at: string }>(
    '/api/me/contact/email/resend/',
    {}
  )
  return data
}

export async function verifyEmailChange(payload: { verification_id: string; code: string }) {
  const { data } = await api.post<{ ok: boolean; email: string; email_verified: boolean }>(
    '/api/me/contact/email/verify/',
    payload
  )
  return data
}

export async function setMyAge(payload: { date_of_birth: string; confirm: boolean }) {
  const { data } = await api.post<{
    ok: boolean
    dob_set: boolean
    age_group: 'unknown' | 'child' | 'teen' | 'adult'
    age_verification_status: 'not_set' | 'self_attested' | 'verified'
    sensitive_content_pref: 'hide' | 'blur' | 'show'
  }>('/api/me/age/', payload)
  return data
}

export async function enableAdultContent(payload: { accept_terms_version: string }) {
  const { data } = await api.post<{
    ok: boolean
    adult_access_state: 'locked' | 'eligible' | 'enabled'
    has_payment_method_on_file: boolean
    adult_terms_version_current: string
  }>('/api/me/adult/enable/', payload)
  return data
}

export async function disableAdultContent() {
  const { data } = await api.post<{ ok: boolean; adult_access_state: 'locked' | 'eligible' | 'enabled' }>(
    '/api/me/adult/disable/',
    {}
  )
  return data
}

export type SecurityDevice = {
  id: number
  platform: 'ios' | 'android' | 'web' | 'unknown'
  app_version?: string | null
  created_at: string
  last_seen_at: string
  device_label: string
  token_suffix: string
}

export async function listSecurityDevices() {
  const { data } = await api.get<SecurityDevice[]>('/api/notifications/devices/')
  return data
}

export async function removeSecurityDevice(id: number) {
  await api.delete(`/api/notifications/devices/${id}/`)
  return true
}
